import React, { useEffect, useState } from "react";
import {
  PrinterFill,
  Cart,
  CheckCircle,
  Truck,
  GearFill,BoxSeam,
  HouseDoor
} from "react-bootstrap-icons";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import api from "../admin/api/api";
import "./OrderDetails.scss";
import TopSelling from "../Components/TopSelling";
import { image_base_url } from "../admin/api/api";

function OrderDetails() {

  const { orderId } = useParams();

  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) {
      getOrderDetails();
    }
  }, [orderId]);

  const getOrderDetails = async () => {

    try {

      const response = await api.get(`/Orders/details/${orderId}`);

      setOrder(response.data);

    } catch (error) {
      console.log(error);
    }

  };

  if (!order) {
    return <h2>Loading...</h2>;
  }

  /* Tracking Steps */

  const steps = [
    { title: "Pending", icon: <Cart /> },
    { title: "Confirmed", icon: <CheckCircle /> },
    { title: "Processing", icon: <BoxSeam /> },
    { title: "Shipped", icon: <Truck /> },
    { title: "Delivered", icon: <HouseDoor /> }
  ];

  const currentIndex = steps.findIndex(
    s => s.title.toLowerCase() === order.status.toLowerCase()
  );

  return (
    <div className="order-details-container container pt-4">

      <h3 className="border-bottom pb-3 mb-3">
        Order #{order.orderNo}
      </h3>

      {/* ORDER SUMMARY */}

      <div className="order-summary card mb-4">

        <div className="card-body">

          <div className="summary-box">
            <p>Order Date</p>
            <span>
  {new Date(order.orderDate).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  })}
</span>
          </div>

          <div className="summary-box">
            <p>Total Amount</p>
            <span>₹{order.totalAmount}</span>
          </div>

          <div className="summary-box">
            <p>Status</p>
            <span className={`status ${order.status.toLowerCase()}`}>
              {order.status}
            </span>
          </div>

        </div>

      </div>

      {/* TRACKING BAR */}

      <div className="tracking-container">

        {steps.map((step, index) => {

          const active = index <= currentIndex;

          return (

            <div className="tracking-step" key={index}>

              <div className={`tracking-icon ${active ? "active" : ""}`}>
                {step.icon}
              </div>

              <div className="tracking-title">
                {step.title}
              </div>

              {index !== steps.length - 1 && (
                <div
                  className={`tracking-line ${
                    index < currentIndex ? "active" : ""
                  }`}
                ></div>
              )}

            </div>

          );
        })}

      </div>

      {/* PRODUCT LIST */}

<div className="product-section card mt-4">

  <div className="card-body">

    <h5 className="mb-4">Ordered Products</h5>

    {order.items.map((item, index) => (

      <div className="order-product-card" key={index}>

        {/* Product Image */}
        <div className="product-image1">
          <img
            src={`${image_base_url}${item.image}` || "/images/no-image.png"}
            alt={item.productName}
          />
        </div>

        {/* Product Info */}
        <div className="product-info">

          <h6 className="product-name">{item.productName}</h6>

          <div className="product-meta">
            <span>Size : {item.size}</span>
            <span>Color : {item.color}</span>
            <span>Qty : {item.qty}</span>
          </div>

        </div>

        {/* Price */}
        <div className="product-price">
          ₹{item.price}
        </div>

      </div>

    ))}

  </div>

</div>

      {/* ADDRESS */}

      <div className="address-section card mt-4">

        <div className="card-body">

          <h5>Delivery Address</h5>

          <p>{order.customerName}</p>
          <p>{order.address}</p>
          <p>{order.city}</p>
          <p>{order.mobile}</p>

        </div>

      </div>

      {/* ACTION BUTTONS */}

      <div className="action-buttons botton-box mt-3 mb-3">

        <a href={`/invoice/${order.orderId}`} className="btn btn-dark">
          <PrinterFill /> Print Invoice
        </a>

        <a href="/" className="btn btn-outline-success" style={{border :"2px solid green"}}>
          Continue Shopping
        </a>

      </div>

      {/* TOP SELLING PRODUCTS */}
      <Container style={{marginBottom : "20px"}}>.</Container>
      
          <TopSelling />
      
      <Container className="my-5"></Container>
      {/* <TopSellingProducts /> */}

    </div>
  );
}

export default OrderDetails;